import { createSlice } from "@reduxjs/toolkit";
import { getSettings, } from "./_settingsAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const settingsList = createSlice({
  name: "settingsList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
    .addCase(getSettings.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getSettings.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.settings = payload.data || [];
      state.isSuccess = true;
    })
    .addCase(getSettings.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
    })

  
  },
});
